import {Component, OnDestroy, OnInit} from '@angular/core';
import {HeaderFilterService} from '@Common/widgets/general/data-table/services/header-filter.service';
import {DataTableHeaderCommunicationService} from '@Common/widgets/general/data-table';
import {UntypedFormControl} from '@angular/forms';
import {SubSink} from '@Common/core/utils/subsink';
import {MatSelectChange} from '@angular/material/select';
import {DepositService} from '../../../services/deposit/deposit.service';
import {FilterDirCmpDepositsData} from './filter-dir-cmp-deposits.model';
import {DepositState} from '../../../services/deposit/deposit.model';
import {DirCmpEntite} from '../../../services/dircmp/dircmp.model';
import {DirCmpArchiveService} from '../../../services/dircmp/dircmp.service';

@Component({
  selector: 'app-filter-dir-cmp-deposits',
  templateUrl: './filter-dir-cmp-deposits.component.html',
  styleUrls: ['./filter-dir-cmp-deposits.component.scss', '../filter-deposits.component.scss']
})
export class FilterDirCmpDepositsComponent extends HeaderFilterService implements OnInit, OnDestroy {
  dircmpControl = new UntypedFormControl([]);
  dircmps: DirCmpEntite[] = [];
  dircmpDefault: DirCmpEntite;
  private subSink = new SubSink();
  constructor(public dtCommunicationSvc: DataTableHeaderCommunicationService,
              private dirsvcSvc: DirCmpArchiveService,
              private depositSvc: DepositService) {
    super(dtCommunicationSvc);
  }

  ngOnInit(): void {
    this._loadDirCmp(this.data);
  }
  onSelected(event: MatSelectChange) {
    this.dircmpDefault = event.value;
  }
  onCancel(event) {
  }
  toolTip(dirCmp: DirCmpEntite) {
    return `${dirCmp?.acronym} / ${dirCmp?.entite_archivage_obj?.entite_obj?.name}`;
  }
  onValidate(event) {
    const dataEmit = <FilterDirCmpDepositsData> {
      nameComponent: this.name,
      action: 'validate',
      value: this.dircmpDefault,
      condition: this.dircmpDefault ? `sur ${this.dircmpDefault?.acronym} / ${this.dircmpDefault?.entite_archivage_obj?.entite_obj?.name}` : ''
    };
    this.subject.next(dataEmit);
    this.dtCommunicationSvc.filterUsed(this.name, dataEmit);
  }

  sendAllReinit(reinit: boolean) {
    this._sendReinit();
  }

  sendReinit(filterName: string) {
    this._sendReinit();
  }
  private _sendReinit() {
    this.dircmpDefault = null;
    const dataEmit = <FilterDirCmpDepositsData>{nameComponent: this.name, action: 'reinit'};
    this.subject.next(dataEmit);
    this.dtCommunicationSvc.filterUsed(this.name, dataEmit, false);
  }
  private _loadDirCmp(states: DepositState[]) {
    this.subSink.sink = this.depositSvc.dirCmpDeposits(states).subscribe(_entites => {
      this.dircmps = _entites;
      this.dirsvcSvc.sortBy(this.dircmps, 'name');
      if (this.data) {
        this.dircmpDefault = _entites.find(_entite => _entite.id === (<DirCmpEntite> this.data).id) || null;
        if (this.dircmpDefault) {
          this.dircmpControl.patchValue(this.dircmpDefault);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
